

/**
 * 捐贈碼、捐贈單位
 */
let loveCodeObjArray = [];
loveCodeObjArray.push({
    "loveCode": "25999",
    "name_zh-TW": "忠義基金會",
    "name_zh-CN": "忠义基金会",
    "fullName_zh-TW": "財團法人忠義社會福利事業基金會",
    "fullName_zh-CN": "财团法人忠义社会福利事业基金会",
});
loveCodeObjArray.push({
    "loveCode": "885521",
    "name_zh-TW": "兒福聯盟",
    "name_zh-CN": "儿福联盟",
    "fullName_zh-TW": "財團法人中華民國兒童福利聯盟文教基金會",
    "fullName_zh-CN": "财团法人中华民国儿童福利联盟文教基金会"
});
loveCodeObjArray.push({
    "loveCode": "Other",
    "name_zh-TW": "其他捐贈單位",
    "name_zh-CN": "其他捐赠单位",
    "fullName_zh-TW": "其他捐贈單位",
    "fullName_zh-CN": "其他捐赠单位"
});


/**
 * 取得捐贈碼、捐贈單位組成的物件的陣列
 * 回傳
 * [{"loveCode": "25999", "name": "25999 忠義基金會"},{"loveCode": "Other", "name": "其他捐贈單位"}]
 * name: loveCode + 簡稱，但Other的name不包含lovecode
 */
function getLoveCodeAndNameObjArrayByLanguage(language = "zh-TW") {
    // 預設語系
    let defaultLanguage = "zh-TW";
    let loveCodeAndNameArray = [];
    for (let i = 0; i < loveCodeObjArray.length; i++) {
        let loveCode = loveCodeObjArray[i].loveCode;
        let name = "";
        // 依照傳進來的語系取得對應的name，如果取不到則用預設語系
        if (loveCodeObjArray[i]["name_" + language] == undefined || loveCodeObjArray[i]["name_" + language] == "") {
            name = loveCodeObjArray[i]["name_" + defaultLanguage];
        }
        else {
            name = loveCodeObjArray[i]["name_" + language];
        }
        if (loveCode != undefined && loveCode != "" && name != undefined && name != "") {
            let tmpObj = {};
            tmpObj.loveCode = loveCode;
            tmpObj.name = (loveCode == "Other" ? name : (loveCode + " " + name));
            loveCodeAndNameArray.push(tmpObj);
        }
    }
    return loveCodeAndNameArray;
}


/**
 * 將getLoveCodeAndNameObjArrayByLanguage()的回傳的陣列中，以每個元素的loveCode的值作為key，做出一個object後回傳
 * @param {*} language 
 * @returns 
 */
function getLoveCodeJsonByLanguage(language = "zh-TW") {
    let arr = getLoveCodeAndNameObjArrayByLanguage(language)
    let loveCodeJson = {}
    for(let i=0; i<arr.length; i++) {
        let loveCodeObj = arr[i]
        loveCodeJson[loveCodeObj["loveCode"]] = loveCodeObj
    }
    return loveCodeJson
}


/**
 * 從捐贈碼、捐贈單位的陣列中，取得第一個捐贈碼
 */
function getFirstLoveCode() {
    let objArray = getLoveCodeAndNameObjArrayByLanguage()
    if (objArray.length > 0) {
        let loveCode = objArray[0].loveCode;
        return (loveCode != undefined ? loveCode : "");
    }
    return "";
}


/**
 * 使用loveCode和語系取得受贈單位的全名，未取得回傳空字串
 */
function getLoveCodeAndName(loveCode, language = "zh-TW") {
    let defaultLanguage = "zh-TW"; // 預設語系
    let fullName = "";
    // 未傳loveCode
    if (loveCode == undefined || loveCode == "") {
        return fullName;
    }

    // 取得對應loveCode的受贈單位全名
    for (let i = 0; i < loveCodeObjArray.length; i++) {
        let receivedObj = loveCodeObjArray[i];
        if (receivedObj.loveCode == loveCode) {
            // 依照語系取受贈單位全名
            if (receivedObj["fullName_" + language] != undefined || receivedObj["fullName_" + language] != "") {
                fullName = receivedObj["fullName_" + language];
            }
            else {
                fullName = receivedObj["fullName_" + defaultLanguage];
                break;
            }
        }
    }

    return fullName;
}


export default {
    getLoveCodeAndNameObjArrayByLanguage,
    getLoveCodeJsonByLanguage,
    getFirstLoveCode,
    getLoveCodeAndName
}